import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Divider, FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getDocumentId } from "../Utils/documentNumber";

function SalesReturnConfirm({ moveToReturn, currentInvoice, openSalesModal, setOpenSalesModal, isPhase2 }) {
  const { t } = useTranslation();
  const [returnType, setReturnType] = useState("");

  useEffect(() => {
    setReturnType("");
  }, [currentInvoice?.id, openSalesModal]);
    
  return (
    <Box>
      <Dialog
        open={openSalesModal}
        //   onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ fontSize: "16px" }}>
          {isPhase2 ? (
            <>
              <b>{t("Before creating sales return, select return type below.")}</b>
              <Typography variant="body2" sx={{ mt: 2, mb: 0.5 }}>
                {t("Return Type")}
              </Typography>
              <FormControl fullWidth size="small">
                <Select value={returnType} onChange={(event) => setReturnType(event.target.value)} displayEmpty>
                  <MenuItem value="" disabled>{t("Select return type")}</MenuItem>
                  <MenuItem value="CREDIT_NOTE">- {t("Credit Note")}</MenuItem>
                  <MenuItem value="DEBIT_NOTE">+ {t("Debit Note")}</MenuItem>
                </Select>
              </FormControl>
            </>
          ) : (
            <>
              {t("Are you sure you want to move invoice")} <strong>'{getDocumentId(currentInvoice)}'</strong>{" "}
              {t("to sales return?")}
            </>
          )}
        </DialogTitle>
        <Divider />
        <DialogActions>
          <Button onClick={() => setOpenSalesModal(false)}>{t("Cancel")}</Button>
          <Button disabled={isPhase2 && !returnType} onClick={() => moveToReturn(currentInvoice?.id, returnType)}>
            {t("Confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default SalesReturnConfirm;
